import './Radio-4319e717.css';

var classes = {"Radio":"prc-Radio-Radio-Ly4MR"};

export { classes as default };
